export default __webpack_public_path__ + "static/media/1.c34985a7.webp";